import { cn } from '@/lib/utils'
import { useDashboardStore } from '../stores/dashboardStore'

const filters = [
  { label: 'Alle', value: null },
  { label: 'Komm', value: 'communication' },
  { label: 'Status', value: 'status' },
  { label: 'Deler', value: 'parts' },
  { label: 'ERP', value: 'erp' },
] as const

export function LogFilterChips() {
  const eventFilter = useDashboardStore((s) => s.eventFilter)
  const setEventFilter = useDashboardStore((s) => s.setEventFilter)

  return (
    <div className="flex gap-1">
      {filters.map((f) => (
        <button
          key={f.label}
          onClick={() => setEventFilter(f.value)}
          className={cn(
            'text-[11px] px-2 py-1 rounded-xl border transition-colors font-normal',
            eventFilter === f.value
              ? 'border-emerald-500 text-emerald-600 bg-emerald-50'
              : 'border-gray-200 text-gray-400 bg-white hover:border-emerald-500 hover:text-emerald-600'
          )}
        >
          {f.label}
        </button>
      ))}
    </div>
  )
}
